import { List } from 'antd'
import { BreakDataListProps } from './types'
import { useConcreteTestSetTrackerContext } from '../../../../ConcreteTestSetTrackerContext'

function BreakDataList<T>({
  dataSource,
  renderItem,
  sort,
}: BreakDataListProps<T>) {
  const { relations } = useConcreteTestSetTrackerContext()
  return (
    <List
      dataSource={dataSource.sort(sort)}
      split={false}
      size="small"
      loading={{
        spinning: relations.loading,
        // Prevent column spinners from overlapping row actions
        style: { zIndex: 1 },
      }}
      renderItem={(record) => {
        const { label, value } = renderItem(record)
        return (
          <List.Item style={{ padding: '8px 0' }}>
            {label} : {value?.toLocaleString() ?? 'N/A'}
          </List.Item>
        )
      }}
    />
  )
}

export default BreakDataList
